import { ChangeEvent } from "react";

// Material ui
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Formik
import formCadastroEvento from "../schemas/forms";

// Material ui Autocomplete
import Autocomplete from "@mui/material/Autocomplete";

// Interfaces
import { Organizador } from "interfaces/organizador";

// Formik
import FormField from "./EventoFormField";
import { currencyMaskBRL } from "helpers/utils";
import { InputAdornment } from "@mui/material";

// Schemas
const { formField } = formCadastroEvento;
const {
  titulo,
  dataEvento,
  horaLargada,
  inicioIncricao,
  horaInicioInsc,
  fimInscricao,
  horaFinalInsc,
  organizadorId,
  tipoServicoId,
  modalidadeId,
  valorServico,
} = formField;

interface FormFieldsEventoProps {
  listOrganizador: Organizador[];
  listModalidade: any[];
  listTipoServico: any[];
  values: {
    [x: string]: string;
  };
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  handleChange: {
    (e: ChangeEvent<any>): void;
    <T = string | ChangeEvent<any>>(
      field: T
    ): T extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  setFieldTouched: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void;
}

export default function FieldDadosEvento({
  listOrganizador,
  listModalidade,
  listTipoServico,
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
}: FormFieldsEventoProps) {
  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Dados do evento</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Informe os detalhes do evento esportivo, incluindo título, data, hora,
          período de inscrição, organizador, modalidade, tipo de serviço e
          valor.
        </MDTypography>
      </MDBox>

      <MDBox pb={3} px={3}>
        <Grid container spacing={3} sx={{ py: 1 }}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={titulo.type}
              label={titulo.label}
              name={titulo.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.titulo}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              type={dataEvento.type}
              label={dataEvento.label}
              name={dataEvento.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.dataEvento}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              type={horaLargada.type}
              label={horaLargada.label}
              name={horaLargada.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.horaLargada}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ py: 1 }}>
          <Grid item xs={12} sm={3}>
            <FormField
              type={inicioIncricao.type}
              label={inicioIncricao.label}
              name={inicioIncricao.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.inicioIncricao}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              type={horaInicioInsc.type}
              label={horaInicioInsc.label}
              name={horaInicioInsc.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.horaInicioInsc}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              type={fimInscricao.type}
              label={fimInscricao.label}
              name={fimInscricao.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.fimInscricao}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              type={horaFinalInsc.type}
              label={horaFinalInsc.label}
              name={horaFinalInsc.name}
              required
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.horaFinalInsc}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ py: 1 }}>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              value={
                listOrganizador.find(
                  (item) => String(item.id) === String(values.organizadorId)
                ) || null
              }
              options={listOrganizador}
              onChange={(_event, value) =>
                setFieldValue(organizadorId.name, value ? String(value.id) : "")
              }
              getOptionLabel={(option) => option.nomeFantasia}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onBlur={() => setFieldTouched(organizadorId.name, true)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  bindFormik={false}
                  variant="outlined"
                  name={organizadorId.name}
                  required
                  label={organizadorId.label}
                  InputLabelProps={{ shrink: true }}
                  sx={{ background: "white" }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Autocomplete
              value={
                listModalidade.find(
                  (item) => String(item.id) === String(values.modalidadeId)
                ) || null
              }
              options={listModalidade}
              onChange={(_event, value) =>
                setFieldValue(modalidadeId.name, value ? String(value.id) : "")
              }
              getOptionLabel={(option) => option.tipo}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onBlur={() => setFieldTouched(modalidadeId.name, true)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  bindFormik={false}
                  variant="outlined"
                  name={modalidadeId.name}
                  required
                  label={modalidadeId.label}
                  InputLabelProps={{ shrink: true }}
                  sx={{ background: "white" }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Autocomplete
              value={
                listTipoServico.find(
                  (item) => String(item.id) === String(values.tipoServicoId)
                ) || null
              }
              options={listTipoServico}
              onChange={(_event, value) =>
                setFieldValue(tipoServicoId.name, value ? String(value.id) : "")
              }
              getOptionLabel={(option) => option.tipo}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onBlur={() => setFieldTouched(tipoServicoId.name, true)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  bindFormik={false}
                  variant="outlined"
                  name={tipoServicoId.name}
                  required
                  label={tipoServicoId.label}
                  InputLabelProps={{ shrink: true }}
                  sx={{ background: "white" }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormField
              variant="outlined"
              name={valorServico.name}
              type={valorServico.type}
              label={valorServico.label}
              value={currencyMaskBRL(values.valorServico ?? "0")}
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              required
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setFieldValue(
                  valorServico.name,
                  currencyMaskBRL(event.target.value)
                )
              }
              onBlur={handleBlur}
              sx={{ background: "white" }}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
